<template>
  <CRow>
    <CCol col="5">
      <div class="overview-widget__img h-100" :style="{ backgroundImage: `url(${dlImage})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }">

      </div>
    </CCol>
    <CCol col="7">
      <div class="overview-widget__body">
        <label class="small d-block" v-translate translate-context="event_wizard.overview">Message</label>
        <div class="d-flex flex-column align-items-start mb-1">
          <div class="w-100 position-relative">
            <CTextarea :value="selectedSocialText" readonly class="w-100 m-0"/>
            <div class="position-absolute" style="bottom: 12px; right: 12px">
            <CButton color="light" class="btn-circle ml-2" variant="outline" size="sm"
                     @click="copyURL(selectedSocialText, $gettext('Message'))">
              <CIcon name="cipCopy" />
            </CButton>
          </div>
          </div>

          <PDropDown class="mt-2" show-item-selector @change="onChangeLang" :items="langOptions"/>

        </div>
         <label class="small d-block mt-4" v-translate translate-context="event_wizard.overview">Direct event link</label>
        <div class="d-flex align-items-center mb-1" v-if="showShortLink">
          <CInput :value="mediaKit.short_direct_link" readonly class="w-100 m-0"/>
          <div>
            <CButton color="dark" class="btn-circle ml-2" variant="outline" size="sm"
                     @click="copyURL(mediaKit.short_direct_link, $gettext('Direct event link'))">
              <CIcon name="cipCopy" />
            </CButton>
          </div>
        </div>
        <div class="d-flex align-items-center mb-1" v-if="showDirectLink">
          <CInput :value="mediaKit.direct_link" readonly class="w-100 m-0"/>
          <div>
            <CButton color="dark" class="btn-circle ml-2" variant="outline" size="sm"
                     @click="copyURL(mediaKit.direct_link, $gettext('Direct event link'))">
              <CIcon name="cipCopy" />
            </CButton>
          </div>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import PDropDown from "@/domain/core/components/PDropDown.vue";
import {tooltipEventWizard} from "@/domain/eventWizard/components/overview/tooltip";
import dlImage from '@/assets/images/overview/dl.png'

export default {
  name: 'MediaKit',
  components: {PDropDown},

  props: {
    mediaKit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lang: 'en'
    }
  },
  computed: {
    dlImage() {
      return dlImage
    },
    langOptions() {
      return [
        {label: 'EN', value: 'en'},
        {label: 'IT', value: 'it'},
        {label: 'FR', value: 'fr'},
        {label: 'DE', value: 'de'},
      ]
    },
    selectedSocialText() {
      return this.mediaKit.social_text[this.lang]
    },
    tooltip() {
      return tooltipEventWizard.mediaKit
    },
    showShortLink() {
      if (!this.mediaKit.short_direct_link) return false
      return this.mediaKit.short_direct_link
    },
    showDirectLink() {
      if (!this.mediaKit.short_direct_link) return true
      return this.hasPerm('event_wizard.see_raw_url')
    }
  },
  methods: {
    copyURL(url, description) {
      navigator.clipboard.writeText(url);
      this.notifyMessage({text: this.$gettext(description + ' copied!'), messageType: 'success'})
    },
    onChangeLang(lang) {
      this.lang = lang
    }
  }
}
</script>
